import { memo } from '../../lib/teact/teact';

import { useBileliAuthKy } from './bileliAuthI18n';

import './BileliAuthPromo.scss';

// Bileli sign-in promo — the LEFT column of the two-column auth screen.
// Recreates frontend/web's SignInBrandPanel + the design/ "Split-screen brand panel"
// (teal gradient hero, Bileli logo, headline + yellow accent, sub, Duolingo decorative shapes).
// Copy: Russian by default; Kyrgyz via the pre-login switcher (useBileliAuthKy overlay).
const BileliAuthPromo = () => {
  const ky = useBileliAuthKy();

  return (
    <div className="BileliAuthPromo">
      <div className="bileli-logo BileliAuthPromo__logo">
        <span className="bileli-logo__mark" />
        <span className="bileli-logo__wordmark">
          bileli
          <span className="dot">.</span>
        </span>
      </div>

      <div className="BileliAuthPromo__hero">
        <h1 className="BileliAuthPromo__headline">
          {ky ? ky.promoHeadline1 : 'Учи.'}
          {' '}
          {ky ? ky.promoHeadline2 : 'Учись.'}
          <br />
          <span className="BileliAuthPromo__accent">{ky ? ky.promoAccent : 'Расти.'}</span>
        </h1>
        <p className="BileliAuthPromo__sub">
          {ky ? ky.promoSub : 'Платформа для учёбы и преподавания на кыргызском и русском.'}
        </p>
      </div>

      {/* Decorative Duolingo-style shapes (purely visual). */}
      <span className="BileliAuthPromo__shape BileliAuthPromo__shape--circle" />
      <span className="BileliAuthPromo__shape BileliAuthPromo__shape--yellow" />
      <span className="BileliAuthPromo__shape BileliAuthPromo__shape--coral" />
    </div>
  );
};

export default memo(BileliAuthPromo);
